import { CardNames } from '../index';

export enum GuildNames {
  ROCK = 'Rock-Amoto',
  PAPER = 'Paper-Ashi',
  SCISSORS = 'Scisser-Inu'
}

const traitGuildNames = ['Rock', 'Paper', 'Scissors'] as const;
export type NftTraitGuildName = typeof traitGuildNames[number];
export const isNftTraitGuildName = (input: any): input is NftTraitGuildName => {
  return traitGuildNames.includes(input);
};

export type Guild = {
  name: GuildNames;
  traitCode: NftTraitGuildName;
  cardType: CardNames;
};

interface INftGuilds {
  rock: Guild;
  paper: Guild;
  scissors: Guild;
}

export const nftGuilds: INftGuilds = {
  rock: {
    name: GuildNames.ROCK,
    traitCode: 'Rock',
    cardType: CardNames.ROCK
  },
  paper: {
    name: GuildNames.PAPER,
    traitCode: 'Paper',
    cardType: CardNames.PAPER
  },
  scissors: {
    name: GuildNames.SCISSORS,
    traitCode: 'Scissors',
    cardType: CardNames.SCISSORS
  }
};
